import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { CmsPageContentType, DocumentType } from '@rd/types';
import { Observable, switchMap } from 'rxjs';
import { CmsLoadPageContent } from '../store/cms.actions';
import {
  getCmsPageContentByName,
  getCmsPageErrorByName,
  getCmsPageLoadingByName,
  getCmsPageStateByName,
} from '../store/cms.selector';

@Injectable({
  providedIn: 'root',
})
export class CmsFacade {
  private store = inject(Store);

  getContentByName(params: {
    pageName: string;
    pageType: DocumentType;
    locale: string;
  }): Observable<CmsPageContentType | null> {
    const { pageName } = params;

    // There can be multiple content for each language
    return this.store
      .select(getCmsPageStateByName(`${pageName}-${params.locale}`))
      .pipe(
        switchMap((page) => {
          if (!page) {
            this.store.dispatch(CmsLoadPageContent(params));
          }
          return this.store.select(getCmsPageContentByName(pageName));
        }),
      );
  }

  getContentLoadingByName(pageName: string): Observable<boolean> {
    return this.store.select(getCmsPageLoadingByName(pageName));
  }
  getContentErrorByName(pageName: string): Observable<Error | null> {
    return this.store.select(getCmsPageErrorByName(pageName));
  }
}
